<template>
    <el-dialog 
        title="Pause the Fulfillment Request"
        :visible.sync="showForm"
        @open="refresh"
    >
        <p>We'll cancel the following campaigns:</p>

        <div v-loading="loading" class="mt-5">
            <fulfillment-detail-ja-campaigns :ja_campaigns="ja_campaigns" :readonly="true"></fulfillment-detail-ja-campaigns>
        </div>

        <span slot="footer" class="dialog-footer">
            <btn :click="() => showForm = false" cssClass="btn mr-2" icon="fas fa-times">Close</btn>
            <btn :click="cancelRequest" cssClass="btn btn-danger">I'm sure, cancel the campaigns</btn>
        </span>
    </el-dialog>
</template>

<script>
import FulfillmentDetailJaCampaigns from "./fulfillment-detail-ja-campaigns";

export default {
        components: {
            FulfillmentDetailJaCampaigns,
        },
        props: [
            'show',
            'fulfillment_id',
        ],
        data() {
            return {
                loading: true,
                ja_campaigns: [],
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            },
        },
        methods: {
            refresh() {
                this.loading = true;

                return axios.get(url(`de/fulfillment/${this.fulfillment_id}/cancel-dialog`))
                    .then((response) => {
                        this.ja_campaigns = response.data.ja_campaigns;

                        this.loading = false;
                    })
            },
            cancelRequest() {
                return axios.post(url(`de/fulfillment/${this.fulfillment_id}/cancel`)).then((response) => {
                    this.showForm = false;

                    this.$emit('changed');
                });
            }
        },
        mounted() {
        }
    }
</script>
